import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=8d85df8a&"
import script from "./Stock.vue?vue&type=script&lang=js&"
export * from "./Stock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d85df8a')) {
      api.createRecord('8d85df8a', component.options)
    } else {
      api.reload('8d85df8a', component.options)
    }
    module.hot.accept("./Stock.vue?vue&type=template&id=8d85df8a&", function () {
      api.rerender('8d85df8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/Stock.vue"
export default component.exports